/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { EHealthCheckRequestState, IDeviceHealthCheckHistory } from '../../../device-health-check/models';
import { IVehicleWithBoxResponse, IVehicleWithEsnResponse } from '../../models';

export interface IDeviceHealthCheckState {
  selectedStatusItemId: number;
  vehicleWithBoxResponse: IVehicleWithBoxResponse;
  vehicleWithEsnResponse: IVehicleWithEsnResponse;
  pingState: EHealthCheckRequestState;
  resetState: EHealthCheckRequestState;
  pingRequestTransactionId: string;
  history: IDeviceHealthCheckHistory[];
  historyLoading: boolean;
}

export const initialDeviceHealthCheckState: IDeviceHealthCheckState = {
  selectedStatusItemId: null,
  vehicleWithBoxResponse: null,
  vehicleWithEsnResponse: null,
  pingState: EHealthCheckRequestState.NotSent,
  resetState: EHealthCheckRequestState.NotSent,
  pingRequestTransactionId: null,
  history: [],
  historyLoading: true
};
